import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const addPlan: IMcAppType = {
  name: "addPlan_SAP",
  path: "/my-account/add-plan",
  description: "Add a Plan",
  navFlow: NavFlow.FOCUS,
  title: "Add a plan",
  parent: Tab.MORE,
  conditions: {
    intent: "addPlan",
    customerType: CustomerType.sap,
  },
};
